/**
 * Shared styles for the new search experience (search bar + filter button layout).
 * Used by OrdersView, BillingView, and any future views adopting the newSearchExperience flag.
 */
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const useSearchStyles = createStyles({
  filtersContainer: { display: "flex", flexDirection: "column", gap: tokens.spacing[4] },
  search: { display: "flex", flexDirection: "row", alignItems: "center", gap: tokens.spacing[2] },
  searchInput: {
    width: 400,
  },
  searchClearButton: {
    textDecoration: "none",
    padding: 0,
    border: "none",
  },
});
